import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { PlayHistory } from '../../models'
import { PlayHistoryApi } from '../../apis'

export abstract class PlayHistoryService {
  constructor(
    protected api: PlayHistoryApi
  ) { }

  index(videoId: number): Observable<PlayHistory[]> {
    return this.api.index(videoId)
  }

  batchPost(videoId: number, histories: PlayHistory[]): Observable<any> {
    return this.api.batchPost(videoId, histories)
  }

  stat(videoId: number, groupids?: number[]) {
    return this.api.stat(videoId, groupids)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-history/base.ts